export default {
  namespaced: true,
  state: {
    list: [],
    visible: false
  },
  mutations: {
    setVisible(state, value) {
      state.visible = value
    },
    setNotice(state, data) {
      state.list = data
    },
    deleteItem(state, wsMessageId) {
      let targetIndex = state.list.findIndex(item => item.wsMessageId === wsMessageId)
      if (targetIndex > -1) {
        state.list.splice(targetIndex, 1)
      }
    },
    updataNotice(state, id) {
      state.list = state.list.map(item => {
        if (item.id == id) {
          item.isNew = false
        }
        return item
      })
    },
    clear(state) {
      state.list = []
    }
  }
}
